export const FLUSH = '$$event:flush';
export const TRANSACTION_START = '$$event:transactionStart';
export const TRANSACTION_END = '$$event:transactionEnd';
